import React from "react";
import PropTypes from "prop-types";
import * as styles from "./Modal.css";
import CloseIcon from "./icons/CancelIcon";
import { cx } from "emotion";

export class Modal extends React.Component {
    render() {
        const { onRequestClose, renderModal, isOpen, className } = this.props;
        const containerClass = isOpen
            ? styles.modalLayer
            : styles.modalLayerHide;

        return (
            <div
                className={containerClass}
                onClick={e => {
                    e.stopPropagation();
                    onRequestClose();
                }}
            >
                <div
                    className={cx(styles.modalContainer, className)}
                    onClick={e => e.stopPropagation()}
                >
                    <span
                        onClick={() => onRequestClose()}
                        className={styles.closeIcon}
                    >
                        <CloseIcon />
                    </span>
                    {renderModal({ onRequestClose })}
                </div>
            </div>
        );
    }
}

Modal.propTypes = {
    onRequestClose: PropTypes.func.isRequired,
    renderModal: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
        .isRequired,
    isOpen: PropTypes.bool.isRequired,
    className: PropTypes.string
};
